import React, { useState } from "react";
import { Icon, Radio } from "@tinper/next-ui";

import "./SwitchButton.less";

const prefix = "as-switchButton";

const SwitchButton = (props) => {
  const { defaultActiveType = "table" } = props;

  const [activeType, setactiveType] = useState(defaultActiveType);

  const onChange = (type: string) => {
    setactiveType(type);
    const index = props.icontype?.indexOf(type);
    props.onChange && props.onChange(type, index);
  };
  const icontype = [{ icontype: "uf-kapian", mode: "card" }, { icontype: "uf-symlist", mode: "table" }]

  return (
    <span className={prefix}>
      <Radio.Group
        className={`${prefix}-radio`}
        value={activeType}
        onChange={onChange}
      >
        {icontype && icontype.map((item) => (
          <Radio.Button
            key={item.icontype}
            value={item.mode}
            className={`${prefix}-button`}
            uiclickable="true"
          >
            <Icon className={`${prefix}-button-icon`} type={item.icontype} />
          </Radio.Button>
        ))}
      </Radio.Group>
    </span>
  );
};
export default SwitchButton;
